import React from "react";
import { Modal } from "react-bootstrap";

const LogOutModal = ({ show, onClose, onConfirm, screenLabels }) => {
  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="h5">
          {screenLabels?.log_out?.label_value || "Log out"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {screenLabels?.logout_text?.label_value ||
          "Are you sure you want to log out?"}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger fs-15px" onClick={onClose}>
          {screenLabels?.cancel?.label_value || "Cancel"}
        </button>
        <button className="btn btn-primary fs-15px" onClick={onConfirm}>
          {screenLabels?.log_out?.label_value || "Log out"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogOutModal;
